'use client'

import Image from 'next/image'
import { imageUrl } from '@/lib/utils'
import { ImageFragmentFragment } from '@/api'

type Props = {
  src: ImageFragmentFragment
}

export default function Slide({ src }: Props) {
  return (
    <Image
      src={imageUrl(src)}
      alt="shoes"
      width={0}
      height={0}
      className="w-full object-contain"
    />
  )
}
